/*
 * Кластеры Kafka на главной: топики и живые брокеры из Prometheus кластера (Strimzi),
 * статус — из ArgoCD.
 */
import { Typography } from '@material-ui/core';
import { TableColumn } from '@backstage/core-components';
import { AsyncState } from 'react-use/esm/useAsync';
import { routes } from '../../lib/viva';
import { ArgoAppsSummary } from '../argocd';
import { AsyncCell } from '../catalog/cells';
import { datastoreColumns } from '../catalog/columns';
import { BrokerIcon } from '../icons';
import { ResourceCard } from './ResourceCard';
import { BrokerRow, Resources } from './useResources';

const plural = (n: number, one: string, few: string, many: string) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
};

const base = datastoreColumns<BrokerRow>('Брокер', row => (
  <AsyncCell state={row.apps} unavailable="ArgoCD недоступен">
    {apps => <ArgoAppsSummary apps={apps ?? []} />}
  </AsyncCell>
));

const columns: TableColumn<BrokerRow>[] = [
  ...base.slice(0, 3),
  {
    title: 'Топики и брокеры',
    sorting: false,
    render: row => (
      <AsyncCell state={row.kafka} unavailable="Prometheus недоступен">
        {kafka => (
          <Typography variant="body2" noWrap>
            {kafka?.topics ?? 0}{' '}
            {plural(kafka?.topics ?? 0, 'топик', 'топика', 'топиков')}
            <Typography component="span" variant="body2" color="textSecondary">
              {` · ${kafka?.brokers ?? 0} ${plural(
                kafka?.brokers ?? 0,
                'брокер',
                'брокера',
                'брокеров',
              )}`}
            </Typography>
          </Typography>
        )}
      </AsyncCell>
    ),
  },
  ...base.slice(3),
];

export const BrokersCard = ({
  resources,
}: {
  resources: AsyncState<Resources>;
}) => (
  <ResourceCard<BrokerRow>
    icon={<BrokerIcon />}
    title="Брокеры сообщений"
    to={routes.brokers}
    linkText="все брокеры"
    columns={columns}
    rows={resources.value?.brokers}
    loading={resources.loading}
    error={resources.error}
    errorTitle="Не удалось загрузить брокеры"
    emptyText="Брокеров пока нет — создайте Kafka из шаблона «Кластер Kafka»."
    createText="Создать кластер Kafka"
    createTo={routes.newKafka}
  />
);
